module.exports = __webpack_public_path__ + "ShaikAlthmash-6748371c.webp";